import { H3, LI, SVG, UL } from "../../../../AbstractElements";
import { Messages } from "../../../../utils/Constant";
import MessagesBox from "./MessagesBox";

const MessagesHeader = () => {
  return (
    <LI className="onhover-dropdown">
      <div className="message-box">
        <SVG className="svg-color" iconId="Message" />
        <span className="rounded-pill badge-secondary"></span>
      </div>
      <div className={`onhover-show-div message-dropdown`}>
        <H3 className="f-18 mb-0 dropdown-title">{Messages}</H3>
        <UL>
          <MessagesBox />
        </UL>
      </div>
    </LI>
  );
};

export default MessagesHeader;
